document.addEventListener('DOMContentLoaded', function () {




  //Index featured collection slider
  //  var featuredSlider = document.querySelector('#featured-collection-splide');
  //  if (featuredSlider) {
  //   var splide = new Splide(featuredSlider, {
  //     type: 'slide',
  //     perPage: 4,
  //     perMove: 1,
  //     gap: '20px',
  //     arrows: true,
  //     pagination: false,
  //     rewind: false,
  //     breakpoints: {
  //       480: {
  //         perPage: 1.8,
  //         gap: '12px',
  //         perMove: 2,
  //       },
  //       768: {
  //         perPage: 2,
  //         gap: '18px',
  //       },
  //       1024: {
  //         perPage: 3,
  //         gap: '23px',
  //       }
  //     }
  //   });

  //   splide.mount();
  // }


    //-----------------------index featured product slider----------------------
  //  let maingrid = document.querySelector(".main-grid-col.splide");
  //   if (maingrid) {
  //     var splide = new Splide(".main-grid-col.splide", {
  //       type: "slide",
  //       rewind: false,
  //       perPage: 2,
  //       perMove: 1,
  //       gap: "45px",
  //       autoplay: false,
  //       interval: 4000,
  //       pagination: false,
  //       drag: true,
  //       arrows: true, 
  //       breakpoints: {
  //         1440: {
  //           gap: "20px",
  //         },
  //         989: {
  //           perPage: 1,
  //           gap: "15px",
  //         },
  //         767: {
  //           perPage: 2,
  //         },
  //         480: {
  //           perPage: 1,
  //           padding: {
  //             right: "40%"
  //           }
  //         },
  //       },
  //     });

  //   splide.mount();
  //   }


    //-----------Index New Arival slider------------
  var slider = document.querySelector('#new-arrivals-splide');
  if (slider) {
    new Splide('#new-arrivals-splide', {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '20px',
      arrows: true,
      pagination: false,
      breakpoints: {
        480: {
          perPage: 1,
          padding: {
            right: "40%"
          }
        },
        768: {
          perPage: 2,
          gap: '18px',
        },
        1024: {
          perPage: 3,
          gap: '23px',
        }
      }
    }).mount();
  }


    //--------------index popular products slider----------------
    var popularSlider = document.querySelector('.main-grid-col.splide');

    if (popularSlider) {
      new Splide(popularSlider, {
        type: 'slide',
        perPage: 2,
        perMove: 1,
        gap: '30px',
        arrows: true,
        pagination: false,
         breakpoints: {
        1440: {
          gap: "20px",
        },
        989: {
          perPage: 1,
          gap: "15px",
        },
        767: {
          perPage: 2,
        },
        480: {
          perPage: 1,
          padding: {
            right: "40%"
          }
        },
      },
      }).mount();
    }


    //------------------career banner mouse scroll effect-----------
     const triggers = document.querySelectorAll(".scroll-trigger-text");
     if (triggers.length) {
      triggers.forEach(trigger => {
       trigger.addEventListener("click", function () {
           window.scrollBy({
            top: 1000, // adjust scroll amount
            left: 0,
           behavior: "smooth"
          });
         });
      });
     }

     //-------career page Available position slider------------
  const careerSlider = document.querySelector("#career-slider");

  if (careerSlider) {
    const splide = new Splide(careerSlider, {
      type: "slide",      // No loop
      rewind: false,      // Don't go back to first slide
      perPage: 4,
      gap: "20px",
      arrows: true,
      pagination: false,

      breakpoints: {
        1024: {
          perPage: 3,
          padding: {
            right: "0%",
          },
        },
        989: {
          perPage: 2,
          padding: {
            right: "10%",
          },
        },
        749: {
          perPage: 1,
          gap: "18px",
          padding: {
            right: "10%",
          },
        },
      },
    });

    splide.mount();
  }

     



  //--------------stain & protection page plan include slider----------------
  document.querySelectorAll('.plan-includes-section').forEach(function (section) {
        var slider = section.querySelector('.plan-includes-slider');
        if (!slider) return;

        var splide = new Splide(slider, {
          type: "slide",
          perPage: 4,
          gap: '24px',
          arrows: false,
          pagination: false,
          padding: {
            right: "3%"
          },
          breakpoints: {
            1440: {
              padding: {
                right: "5%"
              }
            },
            1200: { 
                perPage: 3
             },
            989: { gap: '20px' },
            768: { perPage: 2 },
            767: { 
              gap: '12px',
              padding: {
                right: "8%"
              }
            },
            480: { 
              perPage: 1,
              padding: {
                right: "2%"
              }
            },
          },
        });

        var bar = section.querySelector('.my-slider-progress-bar');

        splide.on('mounted move', function () {
          var end = splide.Components.Controller.getEnd() + 1;
          var rate = Math.min((splide.index + 1) / end, 1);

          if (bar) {
            bar.style.width = 100 * rate + '%';
          }
        });

        splide.mount();

        var nextBtn = section.querySelector('.splide-next-new');
        var prevBtn = section.querySelector('.splide-prev-new');

        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            splide.go('>');
          });
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            splide.go('<');
          });
        }
      });


  // ---------------------- collection page collection-featured mobile collapsible js --------------------
    const whyShopSection = document.querySelector('.why-shop-section');
    if (!whyShopSection) return;
    const toggles = whyShopSection.querySelectorAll('.why-shop-toggle');
    // Prevent errors if no accordion items
    if (!toggles.length) return;

    toggles.forEach((toggle) => {

      toggle.addEventListener('click', function () {

        const parent = this.closest('.why-shop-item');

        // Safety check
        if (!parent) return;

        const content = parent.querySelector('.why-shop-content');

        // Safety check
        if (!content) return;

        const isActive = content.classList.contains('active');

        // Close all accordions only inside this section
        whyShopSection.querySelectorAll('.why-shop-content').forEach((item) => {
          item.style.maxHeight = null;
          item.classList.remove('active');
        });

        whyShopSection.querySelectorAll('.why-shop-toggle').forEach((btn) => {
          btn.classList.remove('active');
        });

        // Open clicked accordion
        if (!isActive) {

          content.classList.add('active');
          this.classList.add('active');

          content.style.maxHeight = content.scrollHeight + 'px';
        }

      });
    });

    

      
}); // end of document



//---------- Stain and protection and reward page line js (Don't Use It? Don't Lose It section) ----------
document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('care-list');

  // Stop execution if section does not exist
  if (!section) return;

  const items = section.querySelectorAll('.care-item');
  const progressLine = section.querySelector('.progress-line');

  if (!items.length || !progressLine) return;

  function updateTimeline() {
    const sectionTop = section.getBoundingClientRect().top + window.scrollY;
    const sectionHeight = section.offsetHeight;

    const scrollPosition = window.scrollY + window.innerHeight * 0.6;

    let progress = (scrollPosition - sectionTop) / sectionHeight;
    progress = Math.max(0, Math.min(progress, 1));

    //progressLine.style.height = progress * sectionHeight + 'px';
   const startOffset = 15 / 2; // dot height / 2 = 0.75rem ≈ 7.5px
   const endOffset = items[items.length - 1].offsetHeight - startOffset;
  const lineHeight = sectionHeight - endOffset - startOffset;

    progressLine.style.height = progress * lineHeight + 'px';
    items.forEach(function (item) {
      const itemTop = item.getBoundingClientRect().top;

      if (itemTop < window.innerHeight * 0.60) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  }

  window.addEventListener('scroll', updateTimeline);
  updateTimeline();
});


// finincing page card slider on miibile view only
document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('.why-card-slider', {
    type: 'slide',       
    rewind: false,  
    perPage: 3,
    gap: '20px',
    arrows: true,
    pagination: false,

    breakpoints: {
      768: {
        perPage: 1,
        arrows: true,
        pagination: false,
        padding: {
          right: '0%'
        }
      }
    }
  });

  splide.mount();
});